// src/components/AdminDashboard.jsx
import React, { useEffect, useState } from 'react';
import { signInWithPopup, onAuthStateChanged } from "firebase/auth";
import { httpsCallable } from "firebase/functions";
import { auth, googleProvider, functions } from '../firebase';

function AdminDashboard() {
  const [user, setUser] = useState(null);
  const [leaderboard, setLeaderboard] = useState([]);
  const [loading, setLoading] = useState(false);
  const [accessDenied, setAccessDenied] = useState(false);
  const [error, setError] = useState(null);

  // Watch auth state
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, currentUser => {
      setUser(currentUser);
      // reset any previous state
      setLeaderboard([]);
      setAccessDenied(false);
      setError(null);
    });
    return unsubscribe;
  }, []);

  const handleGoogleLogin = () => {
    signInWithPopup(auth, googleProvider).catch(err => {
      console.error("Google sign-in error", err);
      alert("Failed to sign in. Please try again.");
    });
  };

  // Once we have a user, try fetching the leaderboard
  useEffect(() => {
    const fetchLeaderboard = async () => {
      if (!user) return;

      setLoading(true);
      setAccessDenied(false);
      setError(null);

      try {
        const getLeaderboard = httpsCallable(functions, 'getLeaderboard');
        const result = await getLeaderboard();
        setLeaderboard(result.data.leaderboard || []);
      } catch (err) {
        console.error("Failed to load leaderboard", err);
        if (err.code === 'permission-denied') {
          setAccessDenied(true);
        } else {
          setError(err.message);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchLeaderboard();
  }, [user]);

  // 1) Not signed in → show login prompt
  if (!user) {
    return (
      <div className="admin-login">
        <h2>Admin Login</h2>
        <p>You must sign in with the project owner Google account to access this page.</p>
        <button onClick={handleGoogleLogin}>Sign in with Google</button>
      </div>
    );
  }

  // 2) Waiting on backend → loading indicator
  if (loading) {
    return <p>Loading leaderboard…</p>;
  }

  // 3) Cloud fn said “permission-denied”
  if (accessDenied) {
    return <div><strong>Access Denied.</strong> You are not the admin.</div>;
  }

  // 4) Other error
  if (error) {
    return <div><strong>Error:</strong> {error}</div>;
  }

  // 5) Success!
  return (
    <div className="admin-dashboard">
      <h2>All Users Scores (Leaderboard)</h2>
      {leaderboard.length === 0 ? (
        <p>No entries yet.</p>
      ) : (
        <table border="1" cellPadding="5">
          <thead>
            <tr><th>Username</th><th>Score (Correct Answers)</th></tr>
          </thead>
          <tbody>
            {leaderboard.map(entry => (
              <tr key={entry.username}>
                <td>{entry.username}</td>
                <td>{entry.score}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default AdminDashboard;
